import React, { memo, useEffect, useState } from 'react';
import { Box, Alert } from '@mui/material';
import { useCatalogService } from '../services/catalogService';
import type { Portfolio } from '../services/catalogService';
import ServiceComponentManagementPanel from './ServiceComponentManagementPanel';

interface ServiceComponentsTabContentProps {
  isOpen: boolean;
  onCountChange?: (count: number) => void;
}

const ServiceComponentsTabContent: React.FC<ServiceComponentsTabContentProps> = memo(({ isOpen, onCountChange }) => {
  const catalogService = useCatalogService();
  const [portfolios, setPortfolios] = useState<Portfolio[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!isOpen) return;
    let cancelled = false;
    catalogService.listPortfolios()
      .then((result) => { if (!cancelled) setPortfolios(result.portfolios); })
      .catch((err) => { if (!cancelled) setError(err instanceof Error ? err.message : 'Failed to load portfolios'); });
    return () => { cancelled = true; };
  }, [isOpen, catalogService]);

  if (!isOpen) return null;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100%', overflow: 'hidden' }}>
      {error && <Alert severity="error" sx={{ m: 2 }}>{error}</Alert>}
      <ServiceComponentManagementPanel
        portfolios={portfolios}
        isOpen={isOpen}
        onCountChange={onCountChange}
      />
    </Box>
  );
});

ServiceComponentsTabContent.displayName = 'ServiceComponentsTabContent';

export default ServiceComponentsTabContent;
